import { AditionClientConfig, IdentityType, PermissionData, Portal } from '../../interfaces';
import { TcData } from '../../layer/interfaces';

export type MonitoringMetaData = {
  brand: Portal;
  section: AditionClientConfig['section'] | null;
}

export interface MonitoringDataStore {
  meta: MonitoringMetaData,
  counters: MonitoringCounter[],
  durations: MonitoringDuration[]
}

export enum MonitoringCounterNames {
  'lifecycle' = 'lifecycle',
  'local_storage' = 'local_storage',
  'pps_get_request' = 'pps_get_request',
  'pps_post_request' = 'pps_post_request',
  'core_iframe_load' = 'core_iframe_load',
  'adition_iframe_load' = 'adition_iframe_load',
  'layer' = 'layer',
  'permission_model_update' = 'permission_model_update',
  'tcf_data_update' = 'tcf_data_update',
  'tcf_sync' = 'tcf_sync',
  'tcf_cookie_euconsentv2_set' = 'tcf_cookie_euconsentv2_set',
  'tcf_cookie_transfer' = 'tcf_cookie_transfer'
}

export enum MonitoringEventNames {
  'failed' = 'failed',
  'successful' = 'successful',
  // Layer
  'connected' = 'connected',
  'displayed' = 'displayed',
  'next_requested' = 'next_requested',
  'completed' = 'completed',
  // Lifecycle
  'started' = 'started',
  'ended' = 'ended',
  'aborted' = 'aborted',
  // Fetch
  'sent' = 'sent',
  // TCF Sync
  'required' = 'required',
  // localStorage
  'read_failed' = 'read_failed',
  'write_failed' = 'write_failed'
}

export type MonitoringCounter =
  {
    name: MonitoringCounterNames.lifecycle;
    event: MonitoringEventNames.started | MonitoringEventNames.ended | MonitoringEventNames.aborted;
  } |
  {
    name: MonitoringCounterNames.local_storage;
    event: MonitoringEventNames.read_failed | MonitoringEventNames.write_failed;
  } |
  {
    name: MonitoringCounterNames.pps_get_request;
    event: MonitoringEventNames.sent | MonitoringEventNames.failed;
    identityType?: IdentityType;
  } |
  {
    name: MonitoringCounterNames.pps_post_request;
    event: MonitoringEventNames.sent | MonitoringEventNames.failed;
    usecase?: PermissionData['usecase'];
    status?: PermissionData['status'];
    identityType?: IdentityType;
  } |
  {
    name: MonitoringCounterNames.core_iframe_load;
    event: MonitoringEventNames.failed;
  } |
  {
    name: MonitoringCounterNames.adition_iframe_load;
    event: MonitoringEventNames.started | MonitoringEventNames.failed;
  } |
  {
    name: MonitoringCounterNames.layer;
    event: MonitoringEventNames.connected | MonitoringEventNames.next_requested | MonitoringEventNames.completed | MonitoringEventNames.displayed;
  } |
  {
    name: MonitoringCounterNames.permission_model_update;
    event: MonitoringEventNames.successful | MonitoringEventNames.failed;
    usecase: PermissionData['usecase'];
    status: PermissionData['status'];
  } |
  {
    name: MonitoringCounterNames.tcf_data_update;
    event: MonitoringEventNames.successful | MonitoringEventNames.failed;
    tcStatus: TcData['tcStatus'];
  } |
  {
    name: MonitoringCounterNames.tcf_sync;
    event: MonitoringEventNames.started | MonitoringEventNames.failed;
  } |
  {
    name: MonitoringCounterNames.tcf_cookie_euconsentv2_set | MonitoringCounterNames.tcf_cookie_transfer;
    event: MonitoringEventNames.failed;
  }

export enum MonitoringDurationNames {
  'pps_get_request' = 'pps_get_request',
  'pps_post_request' = 'pps_post_request',
  'core_iframe_load' = 'core_iframe_load',
  'adition_iframe_load' = 'adition_iframe_load'
}

export type MonitoringDuration = {
  name: MonitoringDurationNames;
  duration: number;
}
